var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChartGhostDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "684px",
    height: "320px",
    viewBox: "0 0 684 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bar-chart-ghost-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-ghost-dark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.049999997
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(2.000000, 112.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608,81.9628253 L608,208 L576,208 L576,81.9628253 L608,81.9628253 Z M644,50.260223 L644,208 L612,208 L612,50.260223 L644,50.260223 Z M572,117.531599 L572,208 L540,208 L540,117.531599 L572,117.531599 Z M500,144.594796 L500,208 L468,208 L468,144.594796 L500,144.594796 Z M680,20.1040892 L680,208 L648,208 L648,20.1040892 L680,20.1040892 Z M32,20.1040892 L32,208 L0,208 L0,20.1040892 L32,20.1040892 Z M68,0 L68,208 L36,208 L36,0 L68,0 Z M104,45.6208178 L104,208 L72,208 L72,45.6208178 L104,45.6208178 Z M140,58.7657993 L140,208 L108,208 L108,58.7657993 L140,58.7657993 Z M176,45.6208178 L176,208 L144,208 L144,45.6208178 L176,45.6208178 Z M212,81.9628253 L212,208 L180,208 L180,81.9628253 L212,81.9628253 Z M248,103.613383 L248,208 L216,208 L216,103.613383 L248,103.613383 Z M320,87.3754647 L320,208 L288,208 L288,87.3754647 L320,87.3754647 Z M284,113.665428 L284,208 L252,208 L252,113.665428 L284,113.665428 Z M392,45.6208178 L392,208 L360,208 L360,45.6208178 L392,45.6208178 Z M428,87.3754647 L428,208 L396,208 L396,87.3754647 L428,87.3754647 Z M464,112.892193 L464,208 L432,208 L432,112.892193 L464,112.892193 Z M356,68.8178439 L356,208 L324,208 L324,68.8178439 L356,68.8178439 Z M536,138.408922 L536,208 L504,208 L504,138.408922 L536,138.408922 Z",
    id: "Rectangle-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartGhostDark);
export default __webpack_public_path__ + "static/media/bar-chart-ghost-dark.cc6dfc90a5c88295d45c108570f1fda2.svg";
export { ForwardRef as ReactComponent };